export default __webpack_public_path__ + "static/media/heritagelogo.3884299e.jpg";